import { render, staticRenderFns } from "./restrictionStrategyGroupAction.vue?vue&type=template&id=12d2b923"
import script from "./restrictionStrategyGroupAction.vue?vue&type=script&lang=js"
export * from "./restrictionStrategyGroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports